import React, { Component } from "react";
import { connect } from "react-redux";
import {
  updateRotationDirection,
  validateRotationDirection
} from "../actions/";

class RotationDirection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validRotation: true,
      rotation: [
        {
          value: "Counter clockwise, rope underwound",
          orderCode: "1"
        },
        {
          value: "Counter clockwise, rope overwound",
          orderCode: "2"
        },
        {
          value: "Clockwise, rope underwound",
          orderCode: "3"
        },
        {
          value: "Clockwise, rope overwound",
          orderCode: "4"
        }
      ],
      hover: {
        ccru: false,
        ccro: false,
        cwru: false,
        cwro: false
      }
    };
    this.handleOnchange = this.handleOnchange.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.validRot !== this.props.validRot) {
      if (!this.props.validRot) {
        this.setState({
          validRotation: false
        });
      } else {
        this.setState({
          validRotation: true
        });
      }
    }
    // if (this.props.winchType.orderCode !== prevProps.winchType.orderCode) {
    //   this.props.onRotationSelect("");
    //   var ele = document.getElementsByName("rotation_direction");
    //   for (var i = 0; i < ele.length; i++) ele[i].checked = false;
    // }
    if (this.props.previewStatus !== prevProps.previewStatus) {
      this.setState({
        hover: {
          ccru: this.props.rotationDirection.orderCode === "1",
          ccro: this.props.rotationDirection.orderCode === "2",
          cwru: this.props.rotationDirection.orderCode === "3",
          cwro: this.props.rotationDirection.orderCode === "4"
        }
      });
    }
  }

  handleOnchange = selected => {
    this.props.onRotationSelect(JSON.parse(selected.target.value));
    this.props.validateRotationDirection(true);
  };

  onMouseOut(out) {
    this.setState({
      hover: {
        ccru: this.props.rotationDirection.orderCode === "1",
        ccro: this.props.rotationDirection.orderCode === "2",
        cwru: this.props.rotationDirection.orderCode === "3",
        cwro: this.props.rotationDirection.orderCode === "4"
      }
    });
  }

  onMouseOver(hoverIn) {
    var rotation = hoverIn.target.className;
    if (rotation === "rot0 closed" || rotation === "input0 closed") {
      this.setState({
        hover: {
          ...this.state.hover,
          ccru: true
        }
      });
    } else if (rotation === "rot1 closed" || rotation === "input1 closed") {
      this.setState({
        hover: {
          ...this.state.hover,
          ccro: true
        }
      });
    } else if (rotation === "rot2 closed" || rotation === "input2 closed") {
      this.setState({
        hover: {
          ...this.state.hover,
          cwru: true
        }
      });
    } else if (rotation === "rot3 closed" || rotation === "input3 closed") {
      this.setState({
        hover: {
          ...this.state.hover,
          cwro: true
        }
      });
    }
  }

  render() {
    var rotation = this.state.rotation;

    return (
      <div>
        <div className="field-top">Rotation direction and general layout</div>
        <div className="selection-body">
          <p>
            The direction of rotation of the winch and the position of the
            incoming rope is based on the view to the motor side of the winch,
            rope direction in, winch standing on the floor. Possible directions
            of rotation are clockwise (CW) or counter clockwise (CC). The rope
            can come in underwound (below the drum) or overwound (on top of the
            drum).
          </p>
          {this.state.validRotation === false && (
            <p className="warning">Rotation direction is required.</p>
          )}
          <div className="row" onChange={this.handleOnchange}>
            <div className="col-md-6">
              {/* <div className="bordered-box"> */}
              <label
                className={"rot0 " + (!this.state.hover.ccru ? "closed" : "")}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              >
                <input
                  type="radio"
                  value={JSON.stringify(rotation[0])}
                  name="rotation_direction"
                  defaultChecked={
                    this.props.rotationDirection.orderCode ===
                    rotation[0].orderCode
                  }
                  className={"input0 " + (!this.state.hover.ccru ? "closed" : "")}
                  onMouseOver={this.onMouseOver}
                  onMouseOut={this.onMouseOut}
                />{" "}
                {rotation[0].value}
                <div
                  className={
                    "img-container " + (this.state.hover.ccru ? "active" : "")
                  }
                >
                  <img
                    className="item-img"
                    src={"../images/" + rotation[0].value + ".png"}
                    alt={rotation[0].value}
                  />
                </div>
              </label>
              {/* </div> */}
            </div>
            <div className="col-md-6">
              {/* <div className="bordered-box"> */}
              <label
                className={"rot1 " + (!this.state.hover.ccro ? "closed" : "")}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              >
                <input
                  type="radio"
                  value={JSON.stringify(rotation[1])}
                  name="rotation_direction"
                  defaultChecked={
                    this.props.rotationDirection.orderCode ===
                    rotation[1].orderCode
                  }
                  className={"input1 " + (!this.state.hover.ccru ? "closed" : "")}
                  onMouseOver={this.onMouseOver}
                  onMouseOut={this.onMouseOut}
                />{" "}
                {rotation[1].value}
                <div
                  className={
                    "img-container " + (this.state.hover.ccro ? "active" : "")
                  }
                >
                  <img
                    className="item-img"
                    src={"../images/" + rotation[1].value + ".png"}
                    alt={rotation[1].value}
                  />
                </div>
              </label>
              {/* </div> */}
            </div>
            <div className="col-md-6">
              {/* <div className="bordered-box"> */}
              <label
                className={"rot2 " + (!this.state.hover.cwru ? "closed" : "")}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              >
                <input
                  type="radio"
                  value={JSON.stringify(rotation[2])}
                  name="rotation_direction"
                  defaultChecked={
                    this.props.rotationDirection.orderCode ===
                    rotation[2].orderCode
                  }
                  className={"input2 " + (!this.state.hover.ccru ? "closed" : "")}
                  onMouseOver={this.onMouseOver}
                  onMouseOut={this.onMouseOut}
                />{" "}
                {rotation[2].value}
                <div
                  className={
                    "img-container " + (this.state.hover.cwru ? "active" : "")
                  }
                >
                  <img
                    className="item-img"
                    src={"../images/" + rotation[2].value + ".png"}
                    alt={rotation[2].value}
                  />
                </div>
              </label>
              {/* </div> */}
            </div>
            <div className="col-md-6">
              {/* <div className="bordered-box"> */}
              <label
                className={"rot3 " + (!this.state.hover.cwro ? "closed" : "")}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              >
                <input
                  type="radio"
                  value={JSON.stringify(rotation[3])}
                  name="rotation_direction"
                  defaultChecked={
                    this.props.rotationDirection.orderCode ===
                    rotation[3].orderCode
                  }
                  className={"input3 " + (!this.state.hover.ccru ? "closed" : "")}
                  onMouseOver={this.onMouseOver}
                  onMouseOut={this.onMouseOut}
                />{" "}
                {rotation[3].value}
                <div
                  className={
                    "img-container " + (this.state.hover.cwro ? "active" : "")
                  }
                >
                  <img
                    className="item-img"
                    src={"../images/" + rotation[3].value + ".png"}
                    alt={rotation[3].value}
                  />
                </div>
              </label>
              {/* </div> */}
            </div>
          </div>
        </div>
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mType: state.mType,
    winchType: state.winchType,
    rotationDirection: state.rotationDirection,
    previewStatus: state.previewStatus,
    validRot: state.validRot
  };
};

const mapActionToProps = {
  onRotationSelect: updateRotationDirection,
  validateRotationDirection: validateRotationDirection
};

export default connect(
  mapStateToProps,
  mapActionToProps
)(RotationDirection);



// WEBPACK FOOTER //
// ./src/components/rotationDirection.js